export enum PromptTypeEnum {
    INFO = "info",
    WARNING = "warning",
    ERROR = "error",
    SUCCESS = "success",
    QUESTION = "question",
    PROMPT = "prompt"
}